import { Box, IconButton, Link, Typography, Grid } from '@mui/material';
import { Facebook, Instagram, Twitter } from '@mui/icons-material';

function Footer() {
  return (
    <Box sx={{ 
      bgcolor: '#383838', 
      color: 'primary.main', 
      py: 4,
      height: 200,
      alignItems: 'center',
      justifyContent: 'center',
      display: 'flex',
      marginTop: '100px'
    }}>
      <Grid container columns={{xs: 4, sm: 8, md: 12}} spacing={2} sx={{ width: '70%' }}>
        <Grid item xs={4}>RIODPP</Grid>
        <Grid item xs={4}></Grid>
        <Grid item xs={4}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 2 }}>
            <IconButton color="inherit" component={Link} href="https://www.facebook.com/">
              <Facebook />
            </IconButton>
            <IconButton color="inherit" component={Link} href="https://www.instagram.com/">
              <Instagram />
            </IconButton>
            <IconButton color="inherit" component={Link} href="https://twitter.com/">
              <Twitter />
            </IconButton>
            
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="subtitle1" sx={{ textAlign: 'center' }}>
            Copyright © {new Date().getFullYear()}
          </Typography>
        </Grid>
      </Grid>
      
      
    </Box>
  );
}

export default Footer;
